import {
    ApiParameter,
    doesNotHaveExpand,
    get,
    HasPagingParameters,
} from "@insite/client-framework/Services/ApiService";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { BillToCollectionModel, BillToModel } from "@insite/client-framework/Types/ApiModels";

export interface GetCustomBillTosApiParameter extends GetBillTosApiParameter, HasPagingParameters {
    customerNumber?: string;
}

const billTosUrl = "/api/v1/billtos";

export async function getCustomBillTos(parameter: GetCustomBillTosApiParameter): Promise<BillToCollectionModel> {
    const billTos = await get<BillToCollectionModel>(billTosUrl, parameter);
    billTos.billTos?.forEach(o => cleanBillToModel(o, parameter));
    return billTos;
}

function cleanBillToModel(billToModel: BillToModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    if (doesNotHaveExpand(parameter, "shipTos")) {
        delete billToModel.shipTos;
    }
    if (doesNotHaveExpand(parameter, "costCodes")) {
        delete billToModel.costCodes;
    }
    if (doesNotHaveExpand(parameter, "accountsReceivable")) {
        delete billToModel.accountsReceivable;
    }
    if (doesNotHaveExpand(parameter, "validation")) {
        delete billToModel.validation;
        if (billToModel.shipTos) {
            billToModel.shipTos.forEach(o => {
                o.validation = null;
            });
        }
    }
}
